import React from "react";

import { formatDisplayDate } from "../../../helpers/dataHelper";
import { formatCurrency } from "../viewerHelpers";
import {
  Raw277ClaimStatus,
  getCategoryColor,
  getCategoryDescription,
} from "./raw277Helpers";

const Raw277ClaimRow: React.FC<{
  claim: Raw277ClaimStatus;
  index: number;
  isSelected: boolean;
  onSelect: () => void;
}> = ({ claim, index, isSelected, onSelect }) => {
  const primaryStatus = claim.statusInfos[0];
  const categoryCode = primaryStatus?.categoryCode || "";

  return (
    <tr
      className={`border-b border-gray-100 cursor-pointer hover:bg-blue-50 ${isSelected ? "bg-blue-100" : ""}`}
      onClick={onSelect}
    >
      <td className="px-3 py-2 text-md font-medium">{index + 1}</td>
      <td className="px-3 py-2 text-md font-mono">
        {claim.patientControlNumber || "-"}
      </td>
      <td className="px-3 py-2 text-md">
        {claim.dependentName || claim.subscriberName || "-"}
      </td>
      <td className="px-3 py-2 text-md text-gray-600">
        {formatDisplayDate(claim.serviceDateFrom)}
      </td>
      <td className="px-3 py-2 text-md text-right">
        {formatCurrency(claim.chargeAmount)}
      </td>
      <td className="px-3 py-2">
        <span
          className={`inline-block px-2 py-0.5 rounded text-md font-medium ${getCategoryColor(categoryCode)}`}
        >
          {categoryCode}
        </span>
      </td>
      <td
        className="px-3 py-2 text-md text-gray-600 max-w-sm truncate"
        title={getCategoryDescription(categoryCode)}
      >
        {getCategoryDescription(categoryCode)}
      </td>
    </tr>
  );
};

export default Raw277ClaimRow;
